module.exports = __webpack_public_path__ + "static/media/sweet_view_1.9116f82b.jpg";